import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index.vue'
import Dszzc from '../components/dszzc.vue'
import Gsjj from '../components/gsjj.vue'
import Wdjf from '../components/wdjf.vue'
import Fwfw from '../components/fwfw.vue'
import Xmzs from '../components/xmzs.vue'
import Wdtb from '../components/wdtb.vue'
import Xwdt from '../components/xwdt.vue'
import Hyxw from '../components/hyxw.vue'
import Bzzl from '../components/bzzl.vue'
import Lxwm from '../components/lxwm.vue'
import Xwxq from '../components/xwxq.vue'
import PageNotFound from '../components/404.vue'
import Test from '../components/test.vue'




Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/dszzc',
      name: 'Dszzc',
      component: Dszzc
    },
    {
      path: '/gsjj',
      name: 'Gsjj',
      component: Gsjj
    },
    {
      path: '/wdjf',
      name: 'Wdjf',
      component: Wdjf
    },
    {
      path: '/fwfw',
      name: 'Fwfw',
      component: Fwfw
    },
    {
      path: '/xmzs',
      name: 'Xmzs',
      component: Xmzs
    },
    {
      path: '/wdtb',
      name: 'Wdtb',
      component: Wdtb
    },
    {
      path: '/xwdt',
      name: 'Xwdt',
      component: Xwdt
    },
    {
      path: '/hyxw',
      name: 'Hyxw',
      component: Hyxw
    },
    {
      path: '/bzzl',
      name: 'Bzzl',
      component: Bzzl
    },
    {
      path: '/lxwm',
      name: 'Lxwm',
      component: Lxwm
    },
    {
      path: '/xwxq',
      name: 'Xwxq',
      component: Xwxq
    },
    {
        path: '/404',
        name: 'PageNotFound',
        component: PageNotFound,
      },
      {
        path:'*',
        redirect:'/404'
       },
       {
         path:'/test',
         name: 'Test',
         component: Test
        }
  ],
  scrollBehavior (to, from, savedPosition) {
          if (savedPosition) {
              return savedPosition
          } else {
                return { x: 0, y: 0 }
          }

      }
})



// WEBPACK FOOTER //
// ./src/router/index.js